if (document.querySelectorAll('#newsletter-form').length > 0) {
    const newsletterForm = document.getElementById('newsletter-form');
    const baseUrl = 'https://a8f1a4.mailupclient.com/frontend/xmlSubscribe.aspx';
    newsletterForm.addEventListener('submit', function (e) {
        e.preventDefault();
        var formData = new FormData(newsletterForm);
        var email = formData.get('email');

        var params = new URLSearchParams();
        formData.forEach(function (value, key) {
            params.append(key, value);
        });

        params.append('confirm', 'true');
        params.append('retCode', '1');

        var lang = document.documentElement.lang || 'en';

        var url = baseUrl;
        console.log(url);

        var debug = true; // Set to true to enable console logs for debugging

        var isValidEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

        var messaggi = {
            'it': {
                'success': 'Iscrizione avvenuta con successo',
                'generic_error': 'Errore, riprovare',
                'invalid_email': 'Errore! Email non valida.<br>Inserisci un indirizzo email valido.',
                'already_subscribed': 'Attenzione! Iscrizione già avvenuta',
                'ip_not_registered': 'Errore! IP non registrato',
                'unknown_error': 'Errore sconosciuto',
            },
            'en': {
                'success': 'Subscription successful',
                'generic_error': 'Error, please try again',
                'invalid_email': 'Error! Invalid email address.<br>Please enter a valid email.',
                'already_subscribed': 'Warning! Already subscribed',
                'ip_not_registered': 'Error! IP not registered',
                'unknown_error': 'Unknown error',
            }
        }

        var messaggio = '';

        if (email && isValidEmail) {
            fetch(url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                },
                body: params.toString(),
            })
                .then(response => response.text())
                .then(data => {
                    console.log(data);

                    /* Check subscription outcome. */
                    switch (data) {
                        case '0\r\n':
                            if (debug)
                                console.log("MailUp: Operation completed successfully");
                            messaggio = messaggi[lang] ? messaggi[lang]['success'] : messaggi['en']['success'];
                            document.getElementById("nl-response").innerHTML = '<div class="p-4 mt-3 bg-green-800 text-white"><p>' + messaggio + '</p></div>';
                            break;
                        case '1\r\n':
                            if (debug)
                                console.log("MailUp: Generic error");
                            messaggio = messaggi[lang] ? messaggi[lang]['generic_error'] : messaggi['en']['generic_error'];
                            document.getElementById("nl-response").innerHTML = '<div class="p-4 mt-3 bg-green-800 text-white"><p>' + messaggio + '</p></div>';
                            break;
                        case '2\r\n':
                            if (debug)
                                console.log("MailUp: Invalid email address or mobile number");
                            messaggio = messaggi[lang] ? messaggi[lang]['invalid_email'] : messaggi['en']['invalid_email'];
                            document.getElementById("nl-response").innerHTML = '<div class="p-4 mt-3 bg-red-800 text-white"><p>' + messaggio + '</p></div>';
                            break;
                        case '3\r\n':
                            if (debug)
                                console.log("MailUp: Recipient already subscribed");
                            messaggio = messaggi[lang] ? messaggi[lang]['already_subscribed'] : messaggi['en']['already_subscribed'];
                            document.getElementById("nl-response").innerHTML = '<div class="p-4 mt-3 bg-yellow-500 text-black"><p>' + messaggio + '</p></div>';
                            break;
                        case '-1011\r\n':
                            if (debug)
                                console.log("MailUp: IP not registered");
                            messaggio = messaggi[lang] ? messaggi[lang]['ip_not_registered'] : messaggi['en']['ip_not_registered'];
                            document.getElementById("nl-response").innerHTML = '<div class="p-4 mt-3 bg-red-800 text-white"><p>' + messaggio + '</p></div>';
                            break;
                        /* By default, subscribe the user */
                        default:
                            if (debug)
                                console.log("MailUp: Codice restituito sconosciuto");
                            messaggio = messaggi[lang] ? messaggi[lang]['unknown_error'] : messaggi['en']['unknown_error'];
                            document.getElementById("nl-response").innerHTML = '<div class="p-4 mt-3 bg-red-800 text-white"><p>' + messaggio + '</p></div>';
                    } // end of switch

                    _iub.cons_instructions.push([
                        "submit",
                        {
                            writeOnLocalStorage: false,
                            submitElement: document.getElementById("nl-submit-button"),
                            form: {
                                selector:
                                    document.getElementById("newsletter-form"),
                                map: {
                                    subject: {
                                        email: "email",
                                    },
                                    preferences: {
                                        privacy: "privacy",
                                    },
                                },
                            },
                            consent: {
                                legal_notices: [
                                    {
                                        identifier: "privacy_policy",
                                    },
                                    {
                                        identifier: "cookie_policy",
                                    },
                                ],
                            },
                        },
                    ]);
                });
        } else {
            document.getElementById("nl-response").innerHTML = '<div class="p-4 mt-3 bg-red-800 text-white"><p>Per favore, inserisci un indirizzo email valido.</p></div>';
        }
    });
}